/** Case-insensitive A–Z by display name. Stable so equal names keep source order. */
export function sortTaproomOrderableItems<T extends { itemName?: string | null }>(
  items: readonly T[]
): T[] {
  return [...items].sort((a, b) =>
    String(a.itemName ?? '').localeCompare(String(b.itemName ?? ''), undefined, {
      sensitivity: 'base',
    })
  );
}
